import { getField, updateField } from 'vuex-map-fields';

import axios from 'axios';

const state = () => ({
    businessName: null,
    title: null,
    firstName: null,
    lastName: null,
    email: null,
    mainPhoneNumber: null,
    altPhoneNumber: null,
    decisionAuthorisation: null,
    quoteType: null,
    customerReferenceNumber: null,
    hasAcceptedPolicy: null,
    key: null,
})

const getters = {
    getField,

    hasReferenceNumber(state) {
        return (state.quoteType == 'existing') ? true : false;
    }
}

const actions = {
    submit({ state, commit }) {
        return new Promise((resolve, reject) => {
            const {
                businessName,
                title,
                firstName,
                lastName,
                email,
                mainPhoneNumber,
                altPhoneNumber,
                quoteType,
            } = state;

            const payload = {
                businessName,
                title,
                firstName,
                lastName,
                email,
                mainPhoneNumber, 
                altPhoneNumber,
                quoteType,
            };

            axios.post('/quotetoolapi/contact/setpersonaldetails', payload).then(response => {
                const { data } = response;
                commit('updateKey', data.key)
                commit('stepProgress/toggleStep', null, { root: true });
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            })

        });
    }
}

const mutations = {
    updateField,

    updateKey(state, key) {
        state.key = key;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}